/**
 * Removes all element-based children, but *not* text nodes.
 *
 * @param {Element} el
 * @returns {Element}
 */
function removeAllNonTextElementChildren(el) {
  while (el.lastElementChild) {
    el.removeChild(el.lastElementChild);
  }

  return el;
}

function textWithoutChildren(/** @type {Element} */ el) {
  return removeAllNonTextElementChildren(el.cloneNode(true)).textContent;
}

function annoBodyForSelector(/** @type {Element} */ el) {
  const index = el.getAttribute('data-index');
  const post = el.closest('article');

  return post.querySelector(`.post-annotation-2-body[data-index="${index}"]`);
}

function distToTop(/** @type {Element} */ el) {
  const bodyTop = document.body.getBoundingClientRect().top;
  const elTop = el.getBoundingClientRect().top;
  const headerHeight = document
    .querySelector('header')
    .getBoundingClientRect().height;

  return elTop - bodyTop + headerHeight;
}

function recalculateOffset(
  /** @type {Element} */ selector,
  /** @type {Element} */ body
) {
  const selectorOffset = distToTop(selector);

  const title = textWithoutChildren(selector);
  const titleElement = body.querySelector('.title');
  titleElement.textContent = title;

  if (document.body.classList.contains('mobile')) {
    body.style.position = 'static';
    body.style.top = '0';
    body.style.display = 'block';

    return;
  }

  window.requestAnimationFrame(() => {
    body.style.position = 'absolute';
    body.style.top = `${selectorOffset}px`;
    body.style.display = 'block';
  });

  return body;
}

function buildAnnotations() {
  const annotationBodyElement = document.querySelector(
    '.post-annotation-2-body'
  );
  annotationBodyElement.style.display = 'none';

  const annotationSelectorElements = document.querySelectorAll(
    '.post-annotation-2-selector'
  );

  annotationSelectorElements.forEach((element) => {
    const body = annoBodyForSelector(element);

    recalculateOffset(element, body);

    window.requestAnimationFrame(() => {
      recalculateOffset(element, body);
    });

    window.addEventListener('tmp_resize', () => {
      recalculateOffset(element, body);
    });

    window.addEventListener('tmp_reflow', () => {
      recalculateOffset(element, body);
    });

    window.setTimeout(() => {
      recalculateOffset(element, body);
    }, 250);

    window.setTimeout(() => {
      recalculateOffset(element, body);
    }, 2500);
  });
}

buildAnnotations();
